import { ILandingPrimitive } from "src/modules/pe-landing-module/data/interfaces"
import Primitive from "../section/Primitive"

/* Protopia Ecosystem component */
export interface ISpeechBubbleProps {
   primitive: ILandingPrimitive 
}
const SpeechBubbleMinimal  = (props: ISpeechBubbleProps): JSX.Element => {
    const primitive = (props.primitive)
    const data:any  = ( primitive.data || {})  
    
    return <div className='pe-speech-bubble-container'>
        <div className={`speech-bubble ${data.className} speech-bubble-minimal-${primitive.id}`} style={data.style}>
            <div className={`speech-bubble-content `}> 
                <Primitive
                    primitive={{ ...data, isInline: true }}
                />
            </div>
        </div> 
        <svg version="1.1"
            className={`speech-bubble-tail-${primitive.id}`} 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0px" 
            y="0px"
            width={600}
            height={30}
            viewBox="0 0 30 600" 
            xmlSpace="preserve"
        > 
            <polyline 
                className={`speech-bubble-tail-stroke-${primitive.id}`}  
                points={`0,0 8.1,0 8.1,8.6 15.9,0 32.2,0 `}
            />
        </svg>
    </div>
}
export default SpeechBubbleMinimal